module.exports = __webpack_public_path__ + "img/枪王射击.a484ccd8.jpg";